import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import faqArrow from "../../img/trade/faq-arrow.svg";

const QUESTIONS = [
  { qKey: "trade.faq.q1", aKey: "trade.faq.a1" },
  { qKey: "trade.faq.q2", aKey: "trade.faq.a2" },
  { qKey: "trade.faq.q3", aKey: "trade.faq.a3" },
  { qKey: "trade.faq.q4", aKey: "trade.faq.a4" },
  { qKey: "trade.faq.q5", aKey: "trade.faq.a5" },
  { qKey: "trade.faq.q6", aKey: "trade.faq.a6" },
];

function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="mt">
      <div className="glcontainer">
        <h2 className="font-['Montserrat'] font-black text-[32px] xl:text-[64px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none mb-[30px] xl:mb-[40px]">
          {t("trade.faq.title")}
        </h2>
      </div>
      <div className="flex flex-col">
        {QUESTIONS.map((q, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i}
              className="bg-[#f7f7f7] border-b border-[rgba(0,0,0,0.1)] px-[18px] xl:px-[146px] py-[20px] xl:py-[30px] cursor-pointer"
              onClick={() => setOpenIndex(isOpen ? -1 : i)}
            >
              <div className="flex items-start xl:items-center justify-between gap-[20px]">
                <div className="flex flex-col gap-[20px] flex-1">
                  <h3 className="font-['Montserrat'] font-extrabold text-[16px] xl:text-[20px] text-[#020202] leading-normal">
                    {t(q.qKey)}
                  </h3>
                  {isOpen && (
                    <p className="font-['Inter'] font-normal text-[14px] xl:text-[16px] text-[rgba(0,0,0,0.7)] leading-[1.5]">
                      {t(q.aKey)}
                    </p>
                  )}
                </div>
                <div className="shrink-0 w-[14px] h-[14px] xl:w-[14px] xl:h-[14px] flex items-center justify-center mt-[3px] xl:mt-0">
                  <svg className={`${isOpen ? 'rotate-0' : '-rotate-90'} transition-all`} xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M0.70687 9.89941L10.6064 19.7989L20.5059 9.89941M10.6064 19.7989V-8.07047e-05" stroke="#707070" stroke-width="2"/>
                  </svg>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default FAQ;
